import { Row, Col, Input, message } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import sortBy from "lodash/sortBy";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useWindowDimensions } from "../../../lib/useViewport";
import styles from "../../../constants/styles.json";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import messages from "../../../errors/messages.en-IN.json";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import ticSelect from "../../../assets/images/tic.png";
import Loyality from "../../../assets/images/loyalityIcon.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import Gift from "../../../assets/images/giftIcon.svg";
import Credit from "../../../assets/images/creditCardIcon.svg";
import cardType from "../../../assets/images/cardType.svg";
import creditNote from "../../../assets/images/creditNote.svg";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import walletWhite from "../../../assets/images/walletWhite.png";
import DeleteProduct from "../../../assets/images/delete1.svg";
import { KEYPAD_NO_FOCUS } from "../../../lib/keypadNoFocus";

const PaymentPanel = ({
  cart,
  setCart,
  tillData,
  posConfig,
  pricePrecision,
  currenciesList,
  themeJSON,
  showPayments,
  filteredPaymentMethods,
  isShowingAll,
  showPreviousItems,
  showMoreItems,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  amount,
  setAmount,
  overPayedAmount,
  setOverPayedAmount,
  setNumb,
  setIsCardPaymentFlag,
  paymentModalInputRef,
  paymentCardRef,
  onChangeAmount,
  setIsInputFocused,
  requestPayment,
  setDenaminationsKeyboard,
  denaminationsKeyboard,
  currenciesData,
  handleCashPayment,
  handleAmount,
  handleDeletePayment,
  processOrder,
  walletFunc,
  showConfirm,
  modulo,
  CWHardwareController,
  width,
  setIsNewGiftCardFlag,
  setGiftCardMode,
  setShowInputFields,
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: "100%",
        paddingTop: "1.5%",
        paddingBottom: "1.5%",
      }}
    >
      {/* Payment method buttons */}
      <Row style={{ padding: "0 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
        {sortBy(showPayments, "sequenceNo").map((pm, ind) => {
          if (
            (posConfig?.loyaltyApplicable === "N" && pm.isloyalty) ||
            (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.isloyalty) ||
            (!cart?.customer?.iscredit && pm?.iscredit) ||
            pm.name.toLowerCase() === "cafe tips"
          ) {
            return null;
          }
          return (
            <Col span={8} key={pm.finPaymentmethodId}>
              <button
                disabled={amount < 0 && pm.name.toLowerCase() !== "cash"}
                onClick={async () => {
                  if (amount < 0 && pm.name.toLowerCase() !== "cash") return;
                  if (cart.items.length > 0 && pm.name !== "Complete Order") {
                    setNumb(0);
                    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || {
                      orderStartTime: "",
                      orderEndTime: "",
                      paymentStartTime: "",
                    };
                    if (orderTimeDetails.paymentStartTime === "") {
                      orderTimeDetails = {
                        ...orderTimeDetails,
                        paymentStartTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                      };
                      usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
                    }
                    if (pm.isWallet === "Y") walletFunc();
                    // When user selects a gift card payment method, open the
                    // GiftCardDrawer so they can enter card number / pin and
                    // check balance before redeeming. (BUG-1099)
                    if (pm.isGiftCard === true || pm.isGiftCard === "Y" || pm.name?.toLowerCase().includes("gift")) {
                      if (typeof setIsNewGiftCardFlag === "function") {
                        if (typeof setGiftCardMode === "function") setGiftCardMode("redeem");
                        setIsNewGiftCardFlag(true);
                      }
                    }
                    if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig?.enablePaymentData === "Y") {
                      setIsCardPaymentFlag(true);
                    }
                    const currList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                    const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
                    let originalAmount = Math.abs(cart.total) - (cart.paid ?? 0);
                    const smallestDenomination = currList.length > 0 ? currList[0].value : 1;
                    let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;
                    let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                    // Same class as BUG-2103's paymentController.js crash (fixed in paymentProcess.js/
                    // SMPaymentBar.js b82f966a): overpayment is a .toFixed() STRING -- must be parsed
                    // before storage, or `cart.total + overPayedAmount` string-concatenates downstream
                    // and `.toFixed()` on the result throws "not a function".
                    setOverPayedAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? parseFloat(overpayment) : 0);
                    setAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision));
                    setSelectedPaymentMethod(pm);
                    paymentModalInputRef?.current?.focus();
                    setTimeout(() => {
                      paymentModalInputRef?.current?.select();
                    }, 50);
                  }
                  setShowInputFields && setShowInputFields(false);
                }}
                id={`sm-payment-${pm.name.toLowerCase()}`}
                ref={ind === 0 ? paymentCardRef : null}
                style={{
                  backgroundColor: pm.name === "Complete Order" ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#046307C2",
                  border: `1px solid ${themeJSON.paymentMethodsBGColor || "#fff"}`,
                  borderRadius: "7px",
                  height: "8.6vh",
                  width: "100%",
                  cursor: "pointer",
                }}
                tabIndex={0}
                onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                    position: "relative",
                    fontSize: "1vw",
                  }}
                >
                  {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId || (amount < 0 && pm.name.toLowerCase() === "cash") ? (
                    <img src={ticSelect} style={{ top: "-2vh", right: "0", height: "2.1vh", position: "absolute" }} />
                  ) : null}
                  <span className="payment" style={{ color: "#fff", fontSize: "1em" }}>
                    {pm.name.toLowerCase() === "cash" ? (
                      <>
                        {currenciesList[0] ? currenciesList[0].currSymbol : ""}&nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "card" ? (
                      <>
                        <img src={cardType} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "upi" ? (
                      <>
                        <img src={UPI} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm?.iscredit ? (
                      <>
                        <img src={Credit} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "loyalty" ? (
                      <>
                        <img src={Loyality} style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "gift card" ? (
                      <>
                        <img src={Gift} style={{ height: "2.5vh", marginBottom: "0.2em" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "voucher" ? (
                      <>
                        <img src={giftVoucher} style={{ height: "2.5vh", marginBottom: "0.2em" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "credit note" ? (
                      <>
                        <img src={creditNote} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.isWallet === "Y" ? (
                      <>
                        <img src={walletWhite} style={{ height: "2.5vh", marginBottom: "0.2em" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : (
                      <>{pm.name}</>
                    )}
                  </span>
                </div>
              </button>
            </Col>
          );
        })}

        {posConfig?.advanceLayaway === "Y" ? (
          <Col
            span={8}
            onClick={() => {
              if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                message.warning(`${messages.warnings.payment.payment_required}`);
                return;
              }
              if (cart.paid <= cart.total) {
                cart.statusType = "layAway";
                setCart({ ...cart });
                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                  if (result !== 0 && isCashPayment) {
                    message.warning(`${t("cash_payment_error")}`);
                  } else {
                    processOrder("layaway");
                  }
                } else {
                  processOrder("layaway");
                }
              }
            }}
          >
            <button style={{ backgroundColor: "#2F3856", border: "1px solid #fff", borderRadius: "7px", height: "8.6vh", width: "100%", cursor: "pointer" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", color: "#fff" }}>Create Advance</div>
            </button>
          </Col>
        ) : null}

        {showPayments.length < filteredPaymentMethods.length && (
          <Col span={8}>
            <button
              onClick={isShowingAll ? showPreviousItems : showMoreItems}
              style={{ backgroundColor: "#046307C2", border: "1px solid #fff", borderRadius: "7px", height: "8.6vh", width: "100%", cursor: "pointer" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                }}
              >
                <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                  ...
                </span>
              </div>
            </button>
          </Col>
        )}
      </Row>

      {/* Payment summary */}
      <div
        style={{
          background: "#fff",
          height: "23vh",
          width: "95%",
          margin: "0.75% 1% 2.7% 3.5%",
          border: "1px solid #fff",
          borderRadius: "7px",
        }}
      >
        <Row style={{ height: "3vh", marginTop: "3%", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Amount Tendered</p>
          </Col>
          <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", fontSize: "1em" }}>{parseFloat(cart.total).toFixed(pricePrecision)}</p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Change</p>
          </Col>
          <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", fontSize: "1em" }}>
              {(cart.paid ?? 0) + parseFloat(amount) - Math.abs(cart.total) > 0
                ? ((cart.paid ?? 0) + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                : cart?.change <= 0
                  ? "0.00"
                  : cart?.change}
            </p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Overpayment</p>
          </Col>
          <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", fontSize: "1em" }}>{Math.abs(overPayedAmount).toFixed(pricePrecision)}</p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Remaining Due</p>
          </Col>
          <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", fontSize: "1em" }}>
              {parseFloat(Math.abs(cart.total)) >= parseFloat(cart.paid) ? parseFloat(Math.abs(cart.total) - cart.paid).toFixed(pricePrecision) : 0}
            </p>
          </Col>
        </Row>
        <hr style={{ margin: "1vh 1vw" }} />
        <Scrollbars style={{ height: "6.3vh" }}>
          {cart?.advancePayment > 0 &&
            cart.layAway === "Y" &&
            cart?.paymentData?.map((item) => (
              <Row style={{ fontSize: "1vw" }} key={item.name}>
                <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "450", textAlign: "left" }}>
                  <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorizationCode}` : item.name}</p>
                </Col>
                <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
                  <p style={{ textAlign: "right", margin: "0", fontWeight: "500", paddingRight: "1.2vw" }}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  </p>
                </Col>
              </Row>
            ))}
          {cart.payments.map((item) => (
            <Row style={{ fontSize: "1vw" }} key={item.name}>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "450", textAlign: "left" }}>
                <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorization}` : item.name}</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "1vw", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", margin: "0", fontWeight: "500", paddingRight: "1.2vw" }}>
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </p>
                <img
                  src={DeleteProduct}
                  onClick={() => handleDeletePayment(item)}
                  style={{ height: "15px", width: "15px", cursor: "pointer", marginLeft: "1vw", position: "absolute", right: 5, top: "15%" }}
                />
              </Col>
            </Row>
          ))}
        </Scrollbars>
      </div>

      {/* Amount input */}
      <Row style={{ margin: "0 0 0 0" }}>
        <Input
          className="productSearch sm-payment-search totalInput"
          style={{
            borderRadius: "0.5vw",
            height: "7.3vh",
            margin: "0 1% 2.7% 3.5%",
            borderRadius: "5px",
            textAlign: "right",
            fontWeight: "500",
            fontSize: "2.5em",
            borderColor: "#fff",
            color: "#2F3856",
          }}
          value={amount}
          id="sm-total-amount-input"
          onChange={onChangeAmount}
          placeholder="Enter Amount"
          ref={paymentModalInputRef}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          readOnly={cart.items.length > 0 ? false : true}
          disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
          onPressEnter={async () => {
            if (
              selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
              parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
              posConfig?.showPaymentSummary === "Y" &&
              !(await showConfirm())
            ) {
              return;
            }
            const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
            const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
            if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
              if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
              } else {
                requestPayment(selectedPaymentMethod, amount);
              }
            }
          }}
        />
      </Row>

      {/* Denominations keyboard or numeric keyboard */}
      {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
        <Row style={{ padding: "0 1% 0 3.5%" }}>
          <Col span={18}>
            <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
              {currenciesData.map((currency) => (
                <Col span={8} key={currency.value}>
                  <button {...KEYPAD_NO_FOCUS}
                    id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                    className="amt-dial-btn-market"
                    onClick={() => handleCashPayment(currency.value)}
                    disabled={currency.value === 999999}
                    style={{ color: currency.value !== 999999 ? "#0f0718" : "transparent" }}
                  >
                    {currency.value}
                  </button>
                </Col>
              ))}
            </Row>
          </Col>
          <Col span={6}>
            <Row style={{ padding: "0 0 7% 7%" }}>
<button {...KEYPAD_NO_FOCUS}
  className="amt-dial-btn-market"
  id="sm-amount-buttonRemove"
  onClick={() => handleAmount("x")}
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <img
    src={CancelArrow}
    alt="back space"
    style={{
      width: "1.4vw",
      height: "1.4vw",
      objectFit: "contain",
    }}
  />
</button>
            </Row>
            <Row style={{ padding: "0 0 7% 7%" }}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-buttonClear" className="amt-dial-btn-market" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                1,2,3...
              </button>
            </Row>
            <Row style={{ padding: "0 0 0 7%" }}>
              <button {...KEYPAD_NO_FOCUS}
                id="sm-amount-buttonEnter"
                className="amt-dial-btn-market2"
                onClick={async () => {
                  if (amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                    message.warning(`${messages.warnings.payment.refund_amount}`);
                    return;
                  }
                  if (
                    selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                    parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                    posConfig?.showPaymentSummary === "Y" &&
                    !(await showConfirm())
                  ) {
                    return;
                  }
                  const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                  const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                  const isGiftCardOrLoyalty =
                    selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                    selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                    selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                  if (isGiftCardOrLoyalty) {
                    if (parseFloat(Math.abs(cart.total)) > parseFloat(Math.abs(cart.paid))) {
                      if (result !== 0) {
                        message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
                      } else {
                        requestPayment(selectedPaymentMethod, amount);
                        if (parseFloat(Math.abs(cart.total)) > parseFloat(amount)) {
                          if (CWHardwareController) {
                            CWPoleDisplay(cart, "Show due payment", amount);
                          } else {
                            PoleDisplay(cart, "Show due payment", amount);
                          }
                        }
                      }
                    }
                  }
                }}
              >
                Enter
              </button>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
              1
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
              2
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
              3
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS}
              className="amt-dial-btn-market"
              style={{
                background: themeJSON?.keyBoardColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              id="sm-amount-buttonRemove"
              onClick={() => handleAmount("x")}
            >
              <img
                src={CancelArrow}
                alt="back space"
                style={{
                  width: "1.4vw",
                  height: "1.4vw",
                  objectFit: "contain",
                }}
              />
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
              4
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
              5
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS} id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
              6
            </button>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS}
              id="sm-amount-buttonClear"
              className="amt-dial-btn-market"
              style={{ background: themeJSON?.keyBoardColor }}
              onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
            >
              1,2,3...
            </button>
          </Col>
          <Col span={18}>
            <Row gutter={[8, 6]}>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                  7
                </button>
              </Col>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                  8
                </button>
              </Col>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                  9
                </button>
              </Col>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                  0
                </button>
              </Col>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                  00
                </button>
              </Col>
              <Col span={8}>
                <button {...KEYPAD_NO_FOCUS} id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                  .
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <button {...KEYPAD_NO_FOCUS}
              id="sm-amount-buttonEnter"
              className="amt-dial-btn-market2"
              style={{ background: themeJSON?.keyBoardColor }}
              onClick={async () => {
                if (
                  selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                  parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                  posConfig?.showPaymentSummary === "Y" &&
                  !(await showConfirm())
                ) {
                  return;
                }
                const isGiftCardOrLoyalty =
                  selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                  selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                  selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                if (isGiftCardOrLoyalty) {
                  if (parseFloat(Math.abs(cart.total)) > parseFloat(cart?.paid)) {
                    if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                      message.warning(`${t("cash_payment_error")}`);
                    } else {
                      setNumb(0);
                      requestPayment(selectedPaymentMethod, amount);
                    }
                  }
                }
              }}
            >
              Enter
            </button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default PaymentPanel;
